import React, { Component } from 'react';
import shopriteSSORedirectLink from '../../assets/js/shopriteSSORedirectLink.json';
import {LOYALTY_RANGES} from "../../config";

class ShopriteSSO extends Component {
  componentDidMount() {
    const {
      setLoading,
      createNewUserOrSignIn,
      history
    } = this.props;

    let cardNum = 0;
    let customerData = window.CustomerData;

    if (customerData && customerData.frequentShopperNumber) {
      cardNum = customerData.frequentShopperNumber;
      console.log(LOYALTY_RANGES)
      if (!LOYALTY_RANGES.find(r => r.min >= cardNum && r.max <= cardNum)) {
        history.push('/noloyaltycard');
        return
      }
    }
    // If no card number, send them back to ShopRite's login
    else {
      window.location = shopriteSSORedirectLink.url; // complete redirect
      return
    }

    // Show Loading Screen
    setLoading(true);

    // Sign in and redirect
    createNewUserOrSignIn(cardNum)
    .then((isNewUser) => {
      console.log("SSO: User Already seen Tutorial = " + window.localStorage.getItem("adjoy_seenTutorial"))
      if (isNewUser !== true) history.push('/app/campaigns');
      else history.push('/app/tutorial');
    })
    .catch((err) => {
      console.log('ShopriteSSO failed to redirect.');
      console.log(err);
      history.push('/');
    });
  }

  render() {
    return <div></div>;
  }
}

export default ShopriteSSO;



// WEBPACK FOOTER //
// ./src/pages/ShopriteSSO/ShopriteSSO.js